import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportMedicaoTerceirizacaoUseCase } from "../../../presentation/useCases/read/get_report_medicao_terceirizacao_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportMedicaoTerceirizacaoUseCase implements IGetReportMedicaoTerceirizacaoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportMedicaoTerceirizacao(
    requiredMimeType: ReportMimeType | null, IdMedicaoTerceirizacao: number
  ): Promise<ReportData> {
    const response = await this.repository.getReportMedicaoTerceirizacao(
      requiredMimeType, IdMedicaoTerceirizacao
    );

    if (response.mimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `medicao_terceirizacao_${IdMedicaoTerceirizacao}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
